module.exports = __webpack_public_path__ + "media/images/common/qr-dd46326febe1c4a06114fa4be00801ce.gif";